import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';
import {AttributeFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';

export const useAttributeFilterSection = ({
  activeFilters,
  data,
  setFilter,
  isSingleSelect,
}: {
  data: AttributeFilterSection;
  activeFilters: Map<string, Array<string> | undefined>;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    filterSlug?: string;
    singleSelectOnly?: boolean;
  }) => void;
  isSingleSelect?: boolean;
}) => {
  const {label, description, headline, slug, values} = data;
  const normalizedValues = values.map(value => ({
    count: value.productCount,
    id: value.id.toString(),
    label: value.label,
    description: value.description,
    slug: value.slug,
  }));

  const activeSlugFilters = (activeFilters.get(slug) ?? []).filter(value =>
    normalizedValues.map(({id}) => id).includes(value),
  );

  const shouldUseSlugifiedAttributeFilters = useIsSoftFeatureToggleActive(
    'attribute_filters_slugified_ids',
  );

  const handleAttributeClick = (itemId: string, itemSlug?: string) => {
    setFilter({
      filterId: itemId,
      filterSection: slug,
      singleSelectOnly: isSingleSelect,
      ...(shouldUseSlugifiedAttributeFilters && {
        filterSlug: itemSlug,
      }),
    });
  };

  return {
    slug,
    label,
    description,
    headline,
    activeSlugFilters,
    normalizedValues,
    handleAttributeClick,
  };
};
